import { useSearchParams } from 'react-router-dom'

import { NotificationActionAPI } from '@makyoapp/makyo-sdk/api/Notifications'
import { NotificationActionTrigger } from '@makyoapp/makyo-sdk/models/Notifications'
import {
  IOrganizationMemberInviteMetadata,
  IOrganizationTransferOwnershipMetadata,
} from '@makyoapp/makyo-sdk/models/NotificationsMetaData'

import { INVITATION_ACTION_KEY, INVITATION_DATA_KEY } from '@/shared/constants'

export type InviteMetadata =
  | Record<string, string>
  | IOrganizationMemberInviteMetadata
  | IOrganizationTransferOwnershipMetadata

export function useInvite() {
  const [searchParams, setSearchParams] = useSearchParams()
  const action = searchParams.get(INVITATION_ACTION_KEY) as NotificationActionTrigger | null

  let data: InviteMetadata | undefined = undefined

  const rawData = searchParams.get(INVITATION_DATA_KEY)
  if (rawData) {
    switch (action) {
      case NotificationActionTrigger.OrganizationMemberInvite:
        data = NotificationActionAPI.ParseOrganizationMemberInviteMetaData(rawData)
        break
      case NotificationActionTrigger.ChangingOrgOwnership:
        data = NotificationActionAPI.ParseOrganizationTransferOwnershipMetaData(rawData)
        break
      default:
        data = NotificationActionAPI.ParseMetaData(rawData)
        break
    }
  }

  return {
    data,
    action,
    searchParams,
    setSearchParams,
  }
}
